import type { IAutoReviewAdditionalField } from '@user/store/autoReviewSettings'

/** Fields are identified by (fieldId, isCustomField); ids can collide across the two kinds. */
export const isSameField = (
  a: IAutoReviewAdditionalField,
  b: IAutoReviewAdditionalField,
) => a.fieldId === b.fieldId && a.isCustomField === b.isCustomField

export const containsField = (
  list: IAutoReviewAdditionalField[],
  field: IAutoReviewAdditionalField,
) => list.some((item) => isSameField(item, field))

export const toggleField = (
  list: IAutoReviewAdditionalField[],
  field: IAutoReviewAdditionalField,
) =>
  containsField(list, field)
    ? list.filter((item) => !isSameField(item, field))
    : [...list, field]

/** Stable React key / test-id suffix, e.g. `custom-5` or `builtin-5`. */
export const getFieldKey = ({
  fieldId,
  isCustomField,
}: IAutoReviewAdditionalField) =>
  `${isCustomField ? 'custom' : 'builtin'}-${fieldId}`
